import { Interfaces, AppConstants } from "@/core/Export";
import router from "../router";
import VueI18n from "@/i18n";
import { apiService } from "./ApiService";
import { date } from "quasar";

export default class AppEnv {
  appStorage;
  isErrorDialogVisible: boolean = false;
  isCloseBtnExist: boolean = true;
  isInfoMsgs: boolean = false;
  errorDialogMsgs: Array<any> = [];
  isBusy: boolean = false;
  canViewRequestContinuePage: boolean = false;
  canViewRequestFinishApprovePage: boolean = false;
  canViewRequestApprovePage: boolean = false;
  canViewRequestRouteGreenPage: boolean = false;
  canViewRequestRouteGreenFormPage: boolean = false;
  canViewRequestRouteRedPage: boolean = false;
  canViewRequestRouteRedQuestionsPage: boolean = false;
  isSystemDataReady: boolean = false;
  authority: string ="";
  isCompleteDetails: boolean = false;
  requestParams: object = {
    personId: "",
    requestId: "",
    requestNo: "",
    year: 0
  };

  constructor() {
    this.appStorage = new appStorage();
  }

  toUTC(value: string) {
    let extract = date.extractDate(value, "DD/MM/YYYY");
    return new Date(
      Date.UTC(extract.getFullYear(), extract.getMonth(), extract.getDate())
    );
  }

  navigate(route) {
    if (route) router.push(route);
  }

  translate(caption) {
    return VueI18n.t(caption);
  }

  showErrorDialog(msgs: Array<any>, isInfo = false,isCloseBtnExist = true) {
    this.errorDialogMsgs = msgs;
    this.isErrorDialogVisible = true;
    this.isInfoMsgs = isInfo;
    this.isCloseBtnExist = isCloseBtnExist;
  }



  getBooleanValue(value) {
    if (value) {
      return "כן";
    }
    return "לא";
  }

  /** App Constants **/
  private authUser;
  private authToken;
  private autenticated;
  private userId;
  private userRole;

  get UserRole() {
    return this.userRole;
  }

  get AuthUser() {
    return this.authUser;
  }

  set AuthUser(v) {
    this.authUser = v;
  }

  get AuthToken() {
    return this.authToken;
  }

  set AuthToken(v) {
    this.authToken = v;
  }

  get Authenticated() {
    return this.autenticated;
  }

  set Authenticated(v) {
    this.autenticated = v;
  }

  get UserId() {
    return this.userId;
  }

  set UserId(v) {
    this.userId = v;
  }

  get isDevEnv() {
    return process.env.NODE_ENV == "development";
  }
}

export class appStorage {
  private sharedState = {};
  shared(key, value: any = "§") {
    if (value === "§") {
      return this.sharedState[key];
    } else if (value === null) {
      delete this.sharedState[key];
    } else {
      this.sharedState[key] = value;
    }
    return null;
  }

  /** Session State **/
  session(key, value: any = "§") {
    if (window.sessionStorage) {
      if (value === "§") {
        return JSON.parse(
          window.sessionStorage.getItem(AppConstants.AppKey + ":" + key)
        );
      } else if (value === null) {
        window.sessionStorage.removeItem(AppConstants.AppKey + ":" + key);
      } else {
        window.sessionStorage.setItem(
          AppConstants.AppKey + ":" + key,
          JSON.stringify(value)
        );
      }
    }
    return null;
  }

  clearSession() {
    if (window.sessionStorage) window.sessionStorage.clear();
    if (window.localStorage) window.localStorage.clear();
  }

  /** Persistent State **/
  persist(key, value: any = "§") {
    if (window.localStorage) {
      if (value === "§") {
        return JSON.parse(
          window.localStorage.getItem(AppConstants.AppKey + ":" + key)
        );
      } else if (value === null) {
        window.localStorage.removeItem(AppConstants.AppKey + ":" + key);
      } else {
        window.localStorage.setItem(
          AppConstants.AppKey + ":" + key,
          JSON.stringify(value)
        );
      }
    }
    return null;
  }
}
